// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .services-container {
    padding-top: 40px;
} */
.service-title {
    margin-top: 30px;
}
.marketplace-container {
    padding-bottom: 130px;
}

.ourservices_header {
    text-align: left;
    font-size: 36px;
    font-weight: 500;
    padding-bottom: 15px;
    color: #000;
    padding-left: 15px;
}


.bg-grey {
    background-color: #f5f5f5!important;
}
/* .buy_side_representation_image {
    float: left;
    height: 100%;
    width: 100%;
    object-fit: cover;
} */

.buy_side_representation_header {
    color: #333;
    font-size: 30px;
    text-align: left;
    font-weight: 500;
    padding-left: 15px;
    border-left: 5px solid #ff5800;
    margin-bottom: 0;
    line-height: 1;
    margin-bottom: 30px;
}
.card {
    border: 0px solid rgba(0, 0, 0, 0.125);
    border-radius: 0;
}
.card-header {
    padding: 25px;
}
.card-body {
    padding: 25px;
}
.buy_side_header {
    color: #333;
    font-size: 30px;
    text-align: left;
    font-weight: 500;
    padding-left: 15px;
    border-left: 5px solid #ff5800;
    margin-bottom: 0;
    line-height: 1;
}

.buy_side_representation_content {
    font-family: "Gill Sans";
    font-size: 18px;
    line-height: 30px;
    margin-bottom: 20px;
    margin-top: 20px;
}
.buy-side-ul {
    padding-left: 10px;
    list-style: none;
}
.buy-side-ul li {
    font-size: 18px;
}
/* ul {
    list-style: none;
  } */
  
  .buy-side-ul li::before {
    content: "\\2022";
    color: red;
    font-weight: 500;
    display: inline-block; 
    width: 1em;
    margin-left: -1em;
  }
.sell_side_representation_header {
    color: #1c2b69;
    font-size: 45px;
    text-align: left;
    font-weight: medium;
    padding-bottom: 45px;
    padding-top: 20px;
}

.sell_side_representation_content {
    font-size: 20px;
    line-height: 30px;
}

.sell_side_representation_content ul{
    list-style: none;
}

.sell_side_representation_content ul li::before{
    content: '\\2022';
    color: #ff5800;
    font-weight: bold;
   display: inline-block; 
   width: 1em; 
   margin-left: -1em;
   font-size: 30px;
}

.buy_side_representation_content_list_header{
    font-weight: bolder;
}
/* .sell_side_representation_image {

    height: 100%;
    width: 100%;
    object-fit: cover;
} */

.copyrights {
    background-color: #12162b;
    width: 100%;
    height: 52px;
    text-align: center;
    font-size: 15px;
    color: #fff;
    font-weight: medium;
}

.card {
    margin-bottom: 30px;
}
.back-home {
    padding-top: 30px;
}
.ourProcess {
    margin-top: 115px;
}
@media (max-width: 575.98px) { 
    .ourProcess {
        margin-top: 90px;
    } 
    .ourservices_header {
        font-size: 28px;
        padding-bottom: 15px;
    }
    .buy_side_header, .buy_side_representation_header {
        font-size: 24px;
    }
    .card-header {
        padding: 15px;
    }
    .card, .buy_side_representation_header {
        margin-bottom: 15px;
    }
    .buy_side_header {
        margin-top: 15px;
    }
 }
 @media (max-width: 991.98px){
     .market-img{
         width: 100%;
     }
 }`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/pages/services/services.css"],"names":[],"mappings":"AAAA;;GAEG;AACH;IACI,gBAAgB;AACpB;AACA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,kBAAkB;AACtB;;;AAGA;IACI,mCAAmC;AACvC;AACA;;;;;GAKG;;AAEH;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,sCAAsC;IACtC,gBAAgB;AACpB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;;KAEK;;EAEH;IACE,gBAAgB;IAChB,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,UAAU;IACV,iBAAiB;EACnB;AACF;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;GAClB,qBAAqB;GACrB,UAAU;GACV,iBAAiB;GACjB,eAAe;AAClB;;AAEA;IACI,mBAAmB;AACvB;AACA;;;;;GAKG;;AAEH;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,oBAAoB;IACxB;IACA;QACI,eAAe;IACnB;IACA;QACI,aAAa;IACjB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;CACH;CACA;KACI;SACI,WAAW;KACf;CACJ","sourcesContent":["/* .services-container {\n    padding-top: 40px;\n} */\n.service-title {\n    margin-top: 30px;\n}\n.marketplace-container {\n    padding-bottom: 130px;\n}\n\n.ourservices_header {\n    text-align: left;\n    font-size: 36px;\n    font-weight: 500;\n    padding-bottom: 15px;\n    color: #000;\n    padding-left: 15px;\n}\n\n\n.bg-grey {\n    background-color: #f5f5f5!important;\n}\n/* .buy_side_representation_image {\n    float: left;\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n} */\n\n.buy_side_representation_header {\n    color: #333;\n    font-size: 30px;\n    text-align: left;\n    font-weight: 500;\n    padding-left: 15px;\n    border-left: 5px solid #ff5800;\n    margin-bottom: 0;\n    line-height: 1;\n    margin-bottom: 30px;\n}\n.card {\n    border: 0px solid rgba(0, 0, 0, 0.125);\n    border-radius: 0;\n}\n.card-header {\n    padding: 25px;\n}\n.card-body {\n    padding: 25px;\n}\n.buy_side_header {\n    color: #333;\n    font-size: 30px;\n    text-align: left;\n    font-weight: 500;\n    padding-left: 15px;\n    border-left: 5px solid #ff5800;\n    margin-bottom: 0;\n    line-height: 1;\n}\n\n.buy_side_representation_content {\n    font-family: \"Gill Sans\";\n    font-size: 18px;\n    line-height: 30px;\n    margin-bottom: 20px;\n    margin-top: 20px;\n}\n.buy-side-ul {\n    padding-left: 10px;\n    list-style: none;\n}\n.buy-side-ul li {\n    font-size: 18px;\n}\n/* ul {\n    list-style: none;\n  } */\n  \n  .buy-side-ul li::before {\n    content: \"\\2022\";\n    color: red;\n    font-weight: 500;\n    display: inline-block; \n    width: 1em;\n    margin-left: -1em;\n  }\n.sell_side_representation_header {\n    color: #1c2b69;\n    font-size: 45px;\n    text-align: left;\n    font-weight: medium;\n    padding-bottom: 45px;\n    padding-top: 20px;\n}\n\n.sell_side_representation_content {\n    font-size: 20px;\n    line-height: 30px;\n}\n\n.sell_side_representation_content ul{\n    list-style: none;\n}\n\n.sell_side_representation_content ul li::before{\n    content: '\\2022';\n    color: #ff5800;\n    font-weight: bold;\n   display: inline-block; \n   width: 1em; \n   margin-left: -1em;\n   font-size: 30px;\n}\n\n.buy_side_representation_content_list_header{\n    font-weight: bolder;\n}\n/* .sell_side_representation_image {\n\n    height: 100%;\n    width: 100%;\n    object-fit: cover;\n} */\n\n.copyrights {\n    background-color: #12162b;\n    width: 100%;\n    height: 52px;\n    text-align: center;\n    font-size: 15px;\n    color: #fff;\n    font-weight: medium;\n}\n\n.card {\n    margin-bottom: 30px;\n}\n.back-home {\n    padding-top: 30px;\n}\n.ourProcess {\n    margin-top: 115px;\n}\n@media (max-width: 575.98px) { \n    .ourProcess {\n        margin-top: 90px;\n    } \n    .ourservices_header {\n        font-size: 28px;\n        padding-bottom: 15px;\n    }\n    .buy_side_header, .buy_side_representation_header {\n        font-size: 24px;\n    }\n    .card-header {\n        padding: 15px;\n    }\n    .card, .buy_side_representation_header {\n        margin-bottom: 15px;\n    }\n    .buy_side_header {\n        margin-top: 15px;\n    }\n }\n @media (max-width: 991.98px){\n     .market-img{\n         width: 100%;\n     }\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
